import { BrokerStatus } from "@partner/shared/SharedConstants";
import { SubmissionDetailsHeaderData } from "../../submission-details.model";
import { ApplicationData } from "../../../../domain/models/application.model";
import { AdvisorData } from "common";
import { getContactString } from "../../submission-details.data";
import { SubmissionDetailsBannerData } from "../../shared/components/submission-details-banner-section/submission-details-banner-section.model";

export const getProcessingDetailsHeaderData = (brokerStatus: BrokerStatus, advisorData: AdvisorData): SubmissionDetailsHeaderData | undefined => {
  const contactString = getContactString(advisorData);

  switch (brokerStatus) {
    case BrokerStatus.PROCESSING:
      return getProcessingSubmissionDetailsHeaderData(contactString);

    case BrokerStatus.DORMANT:
      return getDormantSubmissionDetailsHeaderData(contactString);

    case BrokerStatus.DECLINED:
      return getDeclinedSubmissionDetailsHeaderData(contactString);

    case BrokerStatus.NOT_INTERESTED:
      return getNotInterestedSubmissionDetailsHeaderData(contactString);

    default:
      return undefined;
  }
}

const getProcessingSubmissionDetailsHeaderData = (contactString: string): SubmissionDetailsHeaderData => {
  return {
    title: "Submission in Review",
    subtitle: `We are currently reviewing your submission and will reach out to you shortly. ${contactString}`,
  }
}

const getDormantSubmissionDetailsHeaderData = (contactString: string): SubmissionDetailsHeaderData => {
  return {
    title: "Submission closed",
    subtitle: `The submission was closed due to inactivity. ${contactString}`,
  }
}

const getDeclinedSubmissionDetailsHeaderData = (contactString: string): SubmissionDetailsHeaderData => {
  return {
    title: "Submission declined",
    subtitle: `Unfortunately we are unable to accept this submission. ${contactString}`,
  }
}

const getNotInterestedSubmissionDetailsHeaderData = (contactString: string): SubmissionDetailsHeaderData => {
  return {
    title: "Submission marked as not interested",
    subtitle: `This submission was marked as not interested. Press the Reactivate button below to allow the submission to complete the underwriting process. ${contactString}`,
  }
}

export const getSubmissionDetailsBannerData = (application: ApplicationData): SubmissionDetailsBannerData | undefined => {
  switch (application.brokerStatus) {
    case BrokerStatus.DECLINED:
      return getDeclinedSubmissionDetailsBannerData(application);

    case BrokerStatus.NOT_INTERESTED:
      return getNotInterestedSubmissionDetailsBannerData(application);

    default:
      return undefined;
  }
}

const getDeclinedSubmissionDetailsBannerData = (application: ApplicationData): SubmissionDetailsBannerData | undefined => {
  if (!application.declinedReason) {
    return undefined;
  }

  return {
    title: "Declined reason",
    description: `${application.declinedReason}`,
  }
}

const getNotInterestedSubmissionDetailsBannerData = (application: ApplicationData): SubmissionDetailsBannerData | undefined => {
  if (!application.lostReason) {
    return undefined;
  }

  const comments = application.lostReasonAdditionalComments ? `; ${application.lostReasonAdditionalComments}` : '';
  return {
    title: "Not interested reason",
    description: `${application.lostReason}${comments}`,
  }
}
